// Khối người tiếp nhận / giải quyết + ghi chú kết quả của một ticket góp ý.

import { formatDateTime } from '@/lib/format'

export interface TicketHandlingFields {
  handledByName?: string | null; handledByPhone?: string | null; handledByRole?: string | null; handledAt?: string | null
  resolvedByName?: string | null; resolvedByPhone?: string | null; resolvedByRole?: string | null; resolvedAt?: string | null
  resolutionNote?: string | null
}

function Who({ label, name, role, phone, at }: { label: string; name?: string | null; role?: string | null; phone?: string | null; at?: string | null }) {
  if (!name) return null
  return (
    <p className="text-xs text-inkSoft">
      <span className="font-semibold text-ink">{label}:</span> {name}
      {role ? ` · ${role}` : ''}
      {phone ? <> · <a href={`tel:${phone}`} className="text-accent hover:underline">{phone}</a></> : null}
      {at ? ` · ${formatDateTime(at)}` : ''}
    </p>
  )
}

export function TicketHandling({ t }: { t: TicketHandlingFields }) {
  if (!t.handledByName && !t.resolvedByName) return null
  return (
    <div className="space-y-1 rounded-lg border border-rule/60 bg-paperSoft p-3">
      <Who label="Tiếp nhận" name={t.handledByName} role={t.handledByRole} phone={t.handledByPhone} at={t.handledAt} />
      <Who label="Giải quyết" name={t.resolvedByName} role={t.resolvedByRole} phone={t.resolvedByPhone} at={t.resolvedAt} />
      {t.resolutionNote && <p className="whitespace-pre-wrap text-xs text-ink">{t.resolutionNote}</p>}
    </div>
  )
}
